import MobileSubroute from "../views/Layout/MobileSubroute.tsx";
import { AuthenticatedRoute } from "../routes/ProtectedRoutes.tsx";
import { PlaceProvider } from "../providers/PlaceProvider.tsx";
import { CampaignProvider } from "../views/Campaign/CampaignContext.tsx";
import SuspenseContainer from "../components/SuspenseContainer/SuspenseContainer.tsx";
import { Outlet } from "react-router-dom";

export const GiftsLayout = () => (
  <MobileSubroute title="views.campaign.giftsChoice.settings">
    <AuthenticatedRoute>
      <PlaceProvider>
        <CampaignProvider>
          <SuspenseContainer>
            <Outlet />
          </SuspenseContainer>
        </CampaignProvider>
      </PlaceProvider>
    </AuthenticatedRoute>
  </MobileSubroute>
);
